import {makeSellerUrl} from '@frontend/helpers'
import type {ChatDetailsData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {getChatHeaderData} from '@frontend/modules/private/chats/heplers/getChatHeaderData'
import {Link} from 'react-router-dom'
import {ChatActionsMenu} from './ChatActionsMenu'

interface Props {
    chat: ChatDetailsData
    // Отображение в мини-чате?
    miniChat?: boolean
    // Удаление чата.
    onDelete: (chat: ChatDetailsData) => void
    // Прочитать все сообщения в чате.
    onReadAllMessages: (chat: ChatDetailsData) => void
    // Показать окно добавления отзыва о продавце.
    onAddReview: (chat: ChatDetailsData) => void
    // Состояние выполнения действия с чатом.
    disabled?: boolean
}

// Данные объявления или исполнителя услуг в заголовке чата.
export function ChatDetailsCardHeaderInfo(props: Props) {

    const {
        chat,
        miniChat,
        disabled,
        onReadAllMessages,
        onDelete,
        onAddReview,
    } = props

    const headerData = getChatHeaderData(chat)

    return (
        <>
            <div className="flex-md-1 flex-container-row mt-3 mt-sm-0">
                <div className="me-3 flex-shrink-0">
                    <div
                        className="d-block img img-thumbnail"
                        style={{
                            backgroundImage: `url("${headerData.coverImage}")`,
                        }}
                    />
                </div>
                <div className="flex-md-1 mt-n1 mt-md-0">
                    <div className="fw-bold">
                        <Link
                            to={makeSellerUrl(chat.otherUser.id)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {headerData.sellerName}
                        </Link>
                    </div>
                    <div>
                        <Link
                            to={headerData.itemUrl}
                            target="_blank"
                            className="cabinet-chat-messages-offered-item-link"
                            rel="noreferrer"
                        >
                            {headerData.title}{headerData.price}
                        </Link>
                    </div>
                </div>
            </div>
            <ChatActionsMenu
                chat={chat}
                miniChat={miniChat}
                disabled={disabled}
                onRead={onReadAllMessages}
                onDelete={onDelete}
                onAddReview={onAddReview}
                verticalIcon
                className="cabinet-chat-dropdown"
            />
        </>
    )
}
